import { Row } from 'farmhub-ui-core';
import styled from 'styled-components';

export const Wrapper = styled(Row)<{
  background: string;
  padding?: string;
  fontSize?: number;
  styles?: any;
  notShowPointer?: boolean;
}>`
  display: flex;
  align-items: center;
  width: fit-content;
  border-radius: 4px;
  padding: ${p => p.padding || '2px 6px'};
  position: relative;
  color: ${p => p.background};
  font-size: ${p => p.fontSize || 12}px !important;
  line-height: ${p => (p.fontSize || 12) + 4}px;

  ${p => (p.notShowPointer ? `` : ` cursor: pointer;`)}

  span {
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }

  &::after {
    display: flex;
    align-items: center;
    content: ' ';
    width: 100%;
    height: 100%;
    border-radius: 3px;
    background: ${p => p.background};
    opacity: 0.2;
    position: absolute;
    top: 0;
    left: 0;
  }

  ${p => p.styles}
`;

export const Dot = styled.div<{ color: string; fontSize?: number }>`
  width: ${p => (p.fontSize || 12) - 3}px;
  height: ${p => (p.fontSize || 12) - 3}px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${p => p.color};
`;
